// The one place composer files are pushed to Supabase Storage.
//
// Used by the send pipeline (lib/outbound-send.ts) for both paperclip
// attachments and pasted images. `upsert: true` makes a retry of the same path
// safe — an attempt that died halfway can be repeated without a conflict.

import { supabase } from './supabase';

const BUCKET = 'ticket-attachments';

/** Upload `file` to `path` in the public attachments bucket and return its
 *  public URL. Throws an Error carrying Storage's message on failure. */
export async function uploadToAttachments(file: File, path: string): Promise<string> {
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    contentType: file.type || 'application/octet-stream',
    upsert: true,
  });
  if (error) throw new Error(error.message);
  return supabase.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;
}
